//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('coops', {
//        templateUrl: 'views/components/views/coops/coops.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'coopsService', function (stateService, coopsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListCoops: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadCoops() {
//                vm.model.itemsListCoops = await coopsService.listCoops();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS
            
//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'coop':
//                        go({ coop_id: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadCoops();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
